import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

export const getEditUrlWithBackUrl = (editUrl: string): string => {
  const backUrl = new URL(editUrl);
  backUrl.searchParams.append('backUrl', window.location.href);
  return backUrl.href;
};

export const useQuery = (): URLSearchParams => {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
};

export const buildQueryParam = <T>(parts?: T[]): string | undefined => parts?.join('~');

export const PAGE_INDEX_PARAM = 'page';

export const getPageFromSearchParams = (searchParams: string): number => {
  const params = new URLSearchParams(searchParams);
  const page = parseInt(params.get(PAGE_INDEX_PARAM) || '1');
  return isNaN(page) || page < 1 ? 1 : page;
};
